import { createContext, useState } from "react";

export const Applys = createContext();

export const ApplyProvider = ({ children }) => {
    const [applyMessage, setApplyMessage] = useState(null);
    return <Applys.Provider value={[applyMessage, setApplyMessage]}>{children}</Applys.Provider>;
};
